// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__+PytG","rotate":"LoadingSpinner_rotate__pkSRF","outline":"LoadingSpinner_outline__-9Bne"};